import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useTicketStore = create(
  persist(
    (set) => ({
      currentTicket: null,
      tickets: [],
      setCurrentTicket: (ticket) => set({ currentTicket: ticket }),
      addTicket: (ticket) => set((state) => ({
        tickets: [ticket, ...state.tickets]
      })),
      setTickets: (tickets) => set({ tickets }),
      clearCurrentTicket: () => set({ currentTicket: null }),
    }),
    {
      name: 'ticket-storage',
    }
  )
);

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      login: (user, token) => set({ user, token, isAuthenticated: true }),
      logout: () => set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
    }
  )
);